// Version checking utility to detect new deployments
export const checkForUpdates = async () => {
  try {
    const response = await fetch('/version.json?t=' + Date.now());
    const data = await response.json();
    
    const currentVersion = localStorage.getItem('app_version');
    const lastCheckedVersion = sessionStorage.getItem('last_checked_version');
    
    // If we already checked this version in this session, skip
    if (lastCheckedVersion === data.version) {
      return { hasUpdate: false, currentVersion: data.version };
    }
    
    // Mark this version as checked in this session
    sessionStorage.setItem('last_checked_version', data.version);
    
    if (currentVersion && currentVersion !== data.version) {
      console.log(`New version available: ${data.version} (current: ${currentVersion})`);
      return {
        hasUpdate: true,
        newVersion: data.version,
        currentVersion: currentVersion
      };
    }
    
    // Store current version
    localStorage.setItem('app_version', data.version);
    
    return {
      hasUpdate: false,
      currentVersion: data.version
    };
  } catch (error) {
    console.error('Error checking for updates:', error);
    return { hasUpdate: false };
  }
};

// Force reload with cache clear
export const forceReload = () => {
  // Update localStorage to new version before reload
  fetch('/version.json?t=' + Date.now())
    .then(res => res.json())
    .then(data => {
      localStorage.setItem('app_version', data.version);
      sessionStorage.setItem('last_checked_version', data.version);
    })
    .catch(() => {})
    .finally(() => {
      // Clear all caches
      if ('caches' in window) {
        caches.keys().then(names => {
          names.forEach(name => caches.delete(name));
        });
      }
      
      // Clear service worker if exists
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistrations().then(registrations => {
          registrations.forEach(registration => registration.unregister());
        });
      }
      
      // Force reload
      setTimeout(() => {
        window.location.reload(true);
      }, 100);
    });
};

// Auto-check for updates periodically
export const startUpdateChecker = (intervalMinutes = 30) => {
  const checkInterval = intervalMinutes * 60 * 1000;
  
  setInterval(async () => {
    const result = await checkForUpdates();
    if (result.hasUpdate) {
      const shouldUpdate = window.confirm(
        `A new version (${result.newVersion}) is available. Would you like to update now?`
      );
      if (shouldUpdate) {
        forceReload();
      }
    }
  }, checkInterval);
};
